import type { AdminFlowWizardStep } from "../models/admin-flow-cards.models";

export const ADMIN_FLOW_WIZARD_STEPS: readonly AdminFlowWizardStep[] = [
  { id: "trigger", title: "Choose a trigger", description: "Start manually or prepare a schedule." },
  { id: "sources", title: "Add data sources", description: "Choose the information this flow will receive." },
  { id: "agents", title: "Configure AI steps", description: "Select tools, instructions and upstream inputs." },
  { id: "outputs", title: "Choose outputs", description: "Prepare text or an email for review." },
  { id: "review", title: "Review flow", description: "Check the complete path before publishing." },
];

export const ADMIN_FLOW_WIZARD_FIELD_CLASS =
  "min-h-10 w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-800";

export const ADMIN_FLOW_WIZARD_ACTION_CLASS =
  "min-h-9 rounded border border-gray-300 px-3 py-2 text-xs font-semibold transition-colors hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:hover:bg-gray-700";
